import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeviceList from "./components/list";
import ToastContainer from "../../components/Common/ToastContainer";

const DevicesPage = () => {
  //meta title
  document.title = "Machines";

  return (
    <>
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs
                    title="Machines"
                />
                <DeviceList />
            </Container>
        </div>
        <ToastContainer />
    </>
  );
};

export default DevicesPage;
